module.exports = __webpack_public_path__ + "img/6.d2a96650.png";